export default __webpack_public_path__ + "static/media/gfk-logo.a8088abf.jpg";